/*
 * VIDEO / VOICE MESSAGE on the product page (22 Oct 2026). See snippets/video-message.liquid.
 *
 * Safety rules for this file, learned on this theme the hard way (Oct 2026):
 *  - no MutationObserver, no polling of the page, nothing that runs on its own;
 *  - everything happens because the customer pressed something;
 *  - any failure leaves the page exactly as it was, with a message in the box.
 */
(function () {
  "use strict";
  var MAX = 60;
  var COUNTDOWN = 3; // seconds of 3-2-1 before recording starts
  // Visible text comes from the theme locales (snippets/video-message.liquid renders
  // window.VideoMessageI18n with `| t`); the English here is only a fallback.
  var EN = {
    err_server: "We couldn't reach our server. Please try again.",
    err_file_type: "Please choose a video or a voice recording.",
    err_file_size: "That file is too big \u2014 please keep it under 100 MB (about a minute of video).",
    one_moment: "One moment\u2026",
    err_generic: "Something went wrong. Please try again.",
    later_label: "To record later \u2014 we'll WhatsApp you a link",
    later_done: "Done \u2014 after you order we'll send you a WhatsApp link to record it.",
    record_now_instead: "Record it now instead",
    err_unsupported: "Recording isn't supported in this browser \u2014 choose a video from your phone instead.",
    start_recording: "Start recording",
    recording_left: "\u25cf Recording \u00b7 [s]s left",
    stop: "Stop",
    cancel: "Cancel",
    err_camera: "We couldn't open your camera. Allow camera and microphone access, or choose a video from your phone.",
    err_mic: "We couldn't open your microphone. Allow microphone access and try again.",
    use_message: "Use this message",
    record_again: "Record again",
    uploading: "Uploading\u2026 [p]%",
    err_start: "Couldn't start your video message.",
    err_upload_start: "Couldn't start the upload.",
    err_upload_unfinished: "The upload didn't finish \u2014 please try again.",
    err_upload_connection: "The upload didn't finish \u2014 please check your connection and try again.",
    err_save: "Couldn't save your message.",
    voice_added: "Voice message added \u2713",
    video_added: "Video message added \u2713",
    voice_added_status: "Voice message added \u2713 It goes with this order.",
    video_added_status: "Video message added \u2713 It goes with this order.",
    record_different: "Record a different one",
    try_again: "Try again",
    err_still_uploading: "Your message is still uploading \u2014 one moment, then add to cart."
  };
  function T(key, vars) {
    var src = window.VideoMessageI18n || {};
    var v = src[key];
    var s = (typeof v === "string" && v && v.indexOf("translation missing") === -1) ? v : EN[key];
    if (vars) for (var k in vars) s = s.split("[" + k + "]").join(String(vars[k]));
    return s;
  }

  function init(root) {
    var cfg = window.VideoMessageConfig || {};
    // Inside the form, or (on the phone layout) beside it, joined by the form's id.
    var form = root.closest("form") || document.getElementById(root.getAttribute("data-vmsg-form") || "");
    var toggle = root.querySelector("[data-vmsg-toggle]");
    var panel = root.querySelector("[data-vmsg-panel]");
    var choices = root.querySelector("[data-vmsg-choices]");
    var stage = root.querySelector("[data-vmsg-stage]");
    var statusEl = root.querySelector("[data-vmsg-status]");
    var errorEl = root.querySelector("[data-vmsg-error]");
    var tokenInput = root.querySelector("[data-vmsg-token]");
    var labelInput = root.querySelector("[data-vmsg-label]");
    var fileInput = root.querySelector("[data-vmsg-file]");
    var busy = false;
    var stream = null, recorder = null, timer = null;

    function show(el, on) { if (on) el.removeAttribute("hidden"); else el.setAttribute("hidden", ""); }
    function err(msg) { errorEl.textContent = msg || ""; show(errorEl, !!msg); }
    function status(msg) { statusEl.textContent = msg || ""; show(statusEl, !!msg); }
    function setCart(token, label) {
      tokenInput.value = token || ""; labelInput.value = label || "";
      tokenInput.disabled = !token; labelInput.disabled = !token;
    }
    function stopStream() {
      if (stream) stream.getTracks().forEach(function (t) { t.stop(); });
      stream = null;
      if (timer) clearInterval(timer);
      timer = null;
    }
    function reset() {
      stopStream(); busy = false; stage.innerHTML = ""; show(stage, false); show(choices, true);
      setCart("", ""); status(""); err("");
    }

    function api(action, body) {
      return fetch(cfg.endpoint + "/" + action, {
        method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).catch(function () { return { ok: false, error: T("err_server") }; });
    }

    function pickMime(kind) {
      var list = kind === "video"
        ? ["video/mp4", "video/webm;codecs=vp9,opus", "video/webm;codecs=vp8,opus", "video/webm"]
        : ["audio/mp4", "audio/webm;codecs=opus", "audio/webm", "audio/ogg"];
      if (typeof MediaRecorder === "undefined") return "";
      for (var i = 0; i < list.length; i++) if (MediaRecorder.isTypeSupported(list[i])) return list[i];
      return "";
    }

    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text) e.textContent = text; return e; }
    // The countdown number, laid over the camera preview (or the mic box for a voice note).
    // Styled here rather than in the snippet so this file can ship on its own. Numbers only,
    // so it reads the same on the Arabic pages.
    function countdownOverlay(kind) {
      var c = el("div", "vmsg__count");
      c.setAttribute("aria-live", "assertive"); c.setAttribute("role", "timer");
      var st = c.style;
      st.position = "absolute"; st.top = st.right = st.bottom = st.left = "0";
      st.display = "none"; st.alignItems = "center"; st.justifyContent = "center";
      st.cursor = "pointer"; st.userSelect = "none"; st.zIndex = "2";
      st.fontFamily = "inherit"; st.fontWeight = "400"; st.lineHeight = "1";
      if (kind === "video") {
        st.background = "rgba(0,0,0,.35)"; st.color = "#fff";
        st.fontSize = "clamp(72px, 24vw, 140px)"; st.textShadow = "0 2px 14px rgba(0,0,0,.45)";
      } else {
        st.background = "inherit"; st.color = "inherit"; st.fontSize = "56px";
      }
      return c;
    }
    function showCount(c, n) {
      c.textContent = String(n); c.style.display = "flex";
      if (c.animate) try {
        c.animate([{ transform: "scale(1.35)", opacity: 0.2 }, { transform: "scale(1)", opacity: 1 }], { duration: 320, easing: "ease-out" });
      } catch (e) { /* cosmetic only */ }
    }
    function button(text, dark, fn) { var b = el("button", "vmsg__btn" + (dark ? " vmsg__btn--dark" : ""), text); b.type = "button"; b.addEventListener("click", fn); return b; }

    // The panel is always open since 22 Oct (design C) — no tick box. Kept for older markup.
    if (toggle) toggle.addEventListener("change", function () {
      show(panel, toggle.checked);
      if (!toggle.checked) reset();
    });

    root.querySelectorAll("[data-vmsg-record]").forEach(function (b) {
      b.addEventListener("click", function () { openRecorder(b.getAttribute("data-vmsg-record")); });
    });

    fileInput.addEventListener("change", function () {
      var f = fileInput.files && fileInput.files[0];
      fileInput.value = "";
      if (!f) return;
      if (!/^(video|audio)\//.test(f.type)) return err(T("err_file_type"));
      if (f.size > 100 * 1024 * 1024) return err(T("err_file_size"));
      review(f, f.type.indexOf("audio/") === 0 ? "voice" : "video");
    });

    root.querySelector("[data-vmsg-later]").addEventListener("click", function () {
      err(""); busy = true; status(T("one_moment"));
      api("start", { brand: cfg.brand, recordLater: true }).then(function (r) {
        busy = false;
        if (!r || !r.ok) { status(""); return err((r && r.error) || T("err_generic")); }
        setCart(r.recordToken, T("later_label"));
        show(choices, false);
        status(T("later_done"));
        var change = el("button", "vmsg__link", T("record_now_instead")); change.type = "button";
        change.addEventListener("click", reset);
        stage.innerHTML = ""; stage.appendChild(change); show(stage, true);
      });
    });

    function openRecorder(kind) {
      err("");
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || typeof MediaRecorder === "undefined") {
        return err(T("err_unsupported"));
      }
      navigator.mediaDevices.getUserMedia(kind === "video" ? { video: { facingMode: "user" }, audio: true } : { audio: true })
        .then(function (s) {
          stream = s;
          show(choices, false); stage.innerHTML = ""; show(stage, true);
          var preview, box;
          if (kind === "video") {
            preview = el("video"); preview.muted = true; preview.autoplay = true;
            preview.setAttribute("muted", ""); preview.setAttribute("autoplay", ""); preview.setAttribute("playsinline", "");
            preview.style.transform = "scaleX(-1)";
            box = el("div"); box.style.position = "relative";
            box.appendChild(preview); stage.appendChild(box); preview.srcObject = s; preview.play().catch(function () {});
          } else {
            box = el("div", "vmsg__mic", "\ud83c\udf99\ufe0f"); box.style.position = "relative";
            stage.appendChild(box);
          }
          // 3-2-1 countdown (2 Nov 2026): pressing Start shows a big 3, 2, 1 over the camera
          // (or the mic) so people can settle in; the recording, and its time limit, only
          // start once it reaches zero. Tapping the number or Cancel stops it.
          var count = countdownOverlay(kind);
          box.appendChild(count);
          var info = el("p", "vmsg__rec", ""); info.hidden = true; stage.appendChild(info);
          var row = el("div", "vmsg__row"); stage.appendChild(row);
          function ready() {
            row.innerHTML = "";
            row.appendChild(button(T("start_recording"), true, countdown));
            row.appendChild(button(T("cancel"), false, reset));
          }
          function stopCountdown() {
            if (timer) clearInterval(timer);
            timer = null; count.style.display = "none"; count.onclick = null;
          }
          function countdown() {
            var n = COUNTDOWN;
            showCount(count, n);
            count.onclick = function () { stopCountdown(); ready(); };
            row.innerHTML = "";
            row.appendChild(button(T("cancel"), false, function () { stopCountdown(); ready(); }));
            timer = setInterval(function () {
              n -= 1;
              if (n > 0) return showCount(count, n);
              stopCountdown();
              if (stream === s) record();
            }, 1000);
          }
          function record() {
            var mime = pickMime(kind);
            var chunks = [];
            recorder = new MediaRecorder(s, mime ? { mimeType: mime } : undefined);
            recorder.ondataavailable = function (e) { if (e.data && e.data.size) chunks.push(e.data); };
            recorder.onstop = function () {
              var blob = new Blob(chunks, { type: recorder.mimeType || mime || (kind === "video" ? "video/webm" : "audio/webm") });
              stopStream();
              review(blob, kind);
            };
            recorder.start(1000);
            var left = MAX; info.hidden = false; info.textContent = T("recording_left", { s: left });
            timer = setInterval(function () {
              left -= 1; info.textContent = T("recording_left", { s: left });
              if (left <= 0 && recorder.state === "recording") recorder.stop();
            }, 1000);
            row.innerHTML = "";
            row.appendChild(button(T("stop"), true, function () { if (recorder.state === "recording") recorder.stop(); }));
          }
          ready();
        })
        .catch(function () {
          err(kind === "video"
            ? T("err_camera")
            : T("err_mic"));
        });
    }

    function review(blob, kind) {
      show(choices, false); stage.innerHTML = ""; show(stage, true); err("");
      var url = URL.createObjectURL(blob);
      var player = el(kind === "video" ? "video" : "audio");
      player.src = url; player.controls = true; player.setAttribute("playsinline", "");
      stage.appendChild(player);
      var row = el("div", "vmsg__row"); stage.appendChild(row);
      row.appendChild(button(T("use_message"), true, function () { upload(blob, kind, row); }));
      row.appendChild(button(T("record_again"), false, function () { URL.revokeObjectURL(url); reset(); }));
    }

    function upload(blob, kind, row) {
      busy = true; err(""); row.innerHTML = "";
      var bar = el("div", "vmsg__bar"); var fill = el("span"); bar.appendChild(fill); row.appendChild(bar);
      status(T("uploading", { p: 0 }));
      var contentType = blob.type || (kind === "video" ? "video/mp4" : "audio/mp4");
      var token;
      api("start", { brand: cfg.brand, recordLater: false })
        .then(function (r) {
          if (!r || !r.ok) throw new Error((r && r.error) || T("err_start"));
          token = r.recordToken;
          return api("upload-url", { token: token, contentType: contentType, size: blob.size });
        })
        .then(function (t) {
          if (!t || !t.ok) throw new Error((t && t.error) || T("err_upload_start"));
          return new Promise(function (resolve, reject) {
            var fd = new FormData(); fd.append("cacheControl", "3600"); fd.append("", blob);
            var xhr = new XMLHttpRequest();
            xhr.open("PUT", t.signedUrl);
            xhr.upload.onprogress = function (e) {
              if (!e.lengthComputable) return;
              var p = Math.round((e.loaded / e.total) * 100); fill.style.width = p + "%"; status(T("uploading", { p: p }));
            };
            xhr.onload = function () { xhr.status >= 200 && xhr.status < 300 ? resolve(t.path) : reject(new Error(T("err_upload_unfinished"))); };
            xhr.onerror = function () { reject(new Error(T("err_upload_connection"))); };
            xhr.send(fd);
          });
        })
        .then(function (path) { return api("complete", { token: token, path: path, contentType: contentType }); })
        .then(function (c) {
          if (!c || !c.ok) throw new Error((c && c.error) || T("err_save"));
          busy = false;
          setCart(token, kind === "voice" ? T("voice_added") : T("video_added"));
          row.innerHTML = "";
          status(kind === "voice" ? T("voice_added_status") : T("video_added_status"));
          row.appendChild(button(T("record_different"), false, reset));
        })
        .catch(function (e) {
          busy = false; status(""); err(e && e.message ? e.message : T("err_generic"));
          row.innerHTML = "";
          row.appendChild(button(T("try_again"), true, function () { upload(blob, kind, row); }));
          row.appendChild(button(T("record_again"), false, reset));
        });
    }

    // Hold Add to cart while a recording is still uploading \u2014 otherwise the order would go
    // without it. Capture phase on the document, so it runs before the theme's own handler.
    if (form) {
      document.addEventListener("submit", function (e) {
        if (e.target !== form || !busy) return;
        e.preventDefault(); e.stopImmediatePropagation();
        err(T("err_still_uploading"));
      }, true);
    }
  }

  function boot() {
    document.querySelectorAll("[data-video-message]").forEach(function (root) {
      if (root.__vmsg) return; root.__vmsg = true;
      try { init(root); } catch (e) { /* never break the product page */ }
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
